export const CodeBlock = ({ children }: { children: React.ReactNode }) => {
  return <pre className="text-xs bg-muted/70 p-2 rounded-md whitespace-pre-wrap overflow-x-auto">{children}</pre>;
};
